export default __webpack_public_path__ + "static/media/GMaduroTorpedoCLosed.bb0da32c.jpg";